import { Spin, Table, TableColumnsType } from "antd";
import React from "react";
import apiClient from "../../../api/axiosConfig.tsx";
import { LoadingOutlined } from "@ant-design/icons";
import { format, parseISO } from "date-fns";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useSelector } from "react-redux";
import { authSelect } from "../../../store/slice/auth.slice.tsx";

const CheckCoupon = () => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [listIndex, setListIndex] = React.useState<any[]>([]);
  const [result, setResult] = React.useState<any[]>([]);
  const { userInfo } = useSelector(authSelect);

  const columns: TableColumnsType<any> = [
    {
      width: "14.29%",
      align: "center",
      title: (
        <div className="flex items-center justify-center max-md:text-sm max-sm:text-xs">
          <span>Cửa hàng</span>
        </div>
      ),
      dataIndex: "EVENT_HDD",
      render: (text: string) => (
        <div>
          <span className="font-semibold text-[pink] max-sm:text-xs">
            {text}
          </span>
        </div>
      ),
    },
    {
      width: "14.29%",
      align: "center",
      title: (
        <div className="flex items-center justify-center max-md:text-sm max-sm:text-xs">
          <span>Mã</span>
        </div>
      ),
      dataIndex: "EVENT_POINT",
      render: (text: string) => (
        <div>
          <span className="font-medium max-sm:text-xs">{text}</span>
        </div>
      ),
    },
    {
      width: "14.29%",
      align: "center",
      title: (
        <div className="flex items-center justify-center max-md:text-sm max-sm:text-xs">
          <span>Loại</span>
        </div>
      ),
      dataIndex: "Category",
      render: (text: string) => (
        <div>
          <span className="font-medium max-sm:text-xs">{text}</span>
        </div>
      ),
    },
    {
      width: "14.29%",
      align: "center",
      title: (
        <div className="flex items-center justify-center max-md:text-sm max-sm:text-xs">
          <span>Tiền giảm</span>
        </div>
      ),
      dataIndex: "Discount",
      render: (text: string) => (
        <div>
          <span className="font-medium text-[pink] max-sm:text-xs">{text}</span>
        </div>
      ),
    },
    {
      width: "14.29%",
      align: "center",
      title: (
        <div className="flex items-center justify-center max-md:text-sm max-sm:text-xs">
          <span>Thực trả</span>
        </div>
      ),
      dataIndex: "Amount",
      render: (text: string) => (
        <div>
          <span className="font-medium max-sm:text-xs">{text}</span>
        </div>
      ),
    },
    {
      width: "14.29%",
      align: "center",
      title: (
        <div className="flex items-center justify-center max-md:text-sm max-sm:text-xs">
          <span>Máy</span>
        </div>
      ),
      dataIndex: "Machine",
      render: (text: string) => (
        <div>
          <span className="font-semibold text-red-600 max-sm:text-xs">
            {text}
          </span>
        </div>
      ),
    },
    {
      width: "7.29%",
      align: "center",
      title: (
        <div className="flex items-center justify-center max-md:text-sm max-sm:text-xs">
          <span>Trạng thái</span>
        </div>
      ),
      dataIndex: "status",
      render: (text: string) => (
        <div>
          <span className="font-semibold bg-pink-300 text-white rounded-full px-[6px] py-[4px] flex justify-center items-center max-sm:text-xs">
            {text}
          </span>
        </div>
      ),
    },
    {
      width: "7%",
      align: "center",
      title: (
        <div className="flex items-center justify-center max-md:text-sm max-sm:text-xs">
          <span>Thời gian</span>
        </div>
      ),
      dataIndex: "Send_date",
      render: (text: string) => (
        <div>
          <span className="font-semibold  text-pink-400 rounded-full px-[6px] py-[4px] flex justify-center items-center max-sm:text-xs">
            {format(parseISO(text), "dd/MM/yyyy")}
          </span>
        </div>
      ),
    },
    {
      width: "5%",
      align: "center",
      title: (
        <div className="flex items-center justify-center max-md:text-sm max-sm:text-xs">
          <span>Xóa</span>
        </div>
      ),
      key: "action",
      render: (_, record) => (
        <div className="flex justify-center">
          <button
            onClick={() => handleDeleteCoupon(record)}
            className="text-red-500 hover:text-red-700 transition-colors"
          >
            <RiDeleteBin6Line size={20} />
          </button>
        </div>
      ),
    },
  ];

  const handleDeleteCoupon = async (record: any) => {
    if (window.confirm("Bạn có chắc chắn muốn xóa coupon này?")) {
      try {
        setLoading(true);
        const res = await apiClient.post(`coupon/deleteCoupon`, {
            code: record.EVENT_POINT,
            userId: userInfo.id
        });
        
          console.log(res);
        if (res?.data?.status) {
          setResult(prevResult => prevResult.filter(item => item !== record));
          console.log(res?.data?.status);
          
          alert("Xóa coupon thành công!");
        } else {
          alert(res?.data?.message || "Xóa coupon thất bại!");
        }
      } catch (error) {
        alert("Xóa coupon thất bại!");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleCreateAccount = async () => {
    setLoading(true);
    const res = await apiClient.post(`coupon/check-coupon`, {
      codes: listIndex,
    });
    if (res?.data?.status && res?.data?.data?.length > 0) {
      setLoading(false);
      setResult(res?.data?.data);
    } else {
      setLoading(false);
      setResult([]);
      alert(res?.data?.message || "Kiểm tra coupon thất bại");
    }
  };

  const classInput =
    "w-full border-[1px] border-[pink] rounded-md px-2 py-2 outline-none";
  const classLable =
    "md:font-semibold text-[pink] max-md:text-[10px] max-md:mb-3";

  return (
    <div className="w-full">
      <div className="text-2xl text-center text-[pink] font-bold">
        KIỂM TRA COUPON
      </div>
      <div className="mb-3">
        <div className={classLable}>
          Nhập mã coupon để kiểm tra (mã gồm 8 chữ số), mỗi mã cách nhau bằng
          dấu "," (ví dụ: 14427358,27139925,78564470...)
        </div>
        <input
          onChange={(value) => {
            setListIndex(value.target.value.split(","));
          }}
          type="text"
          className={classInput}
        />
      </div>

      <div className="flex justify-center">
        <button
          className="mb-4 bg-[pink] text-white py-3 px-6 rounded-md"
          onClick={() => {
            handleCreateAccount();
          }}
        >
          {loading ? (
            <Spin
              className="text-white"
              indicator={<LoadingOutlined color="white" spin />}
              size="small"
            />
          ) : (
            "Kiểm tra"
          )}
        </button>
      </div>

      {result?.length > 0 && (
        <div className="w-full">
          <Table
            columns={columns}
            dataSource={result}
            pagination={false}
            rowKey={(record) => record?.EVENT_HDD}
            className="w-full"
          />
        </div>
      )}
    </div>
  );
};

export default CheckCoupon;
